import React, { Component } from 'react';
import Link from 'gatsby-link';
import GolfHotelLogo from '../../assets/images/logo/golf-hotel-logo.svg';
import GolfLogo from '../../assets/images/logo/golf-logo.svg';
import LeQGLogo from '../../assets/images/logo/leqg-logo.svg';
import TreesomeLogo from '../../assets/images/logo/treesome-logo.svg';
import ArtistoLogo from '../../assets/images/logo/artisto-logo.svg';
import CateringLogo from '../../assets/images/logo/catering-logo.svg';
import FairgroundLogo from '../../assets/images/logo/fairgroundHashtag-logo.svg';
import TiniriCampLogo from '../../assets/images/logo/tiniricamp-logo.svg';
import {
  artistoPath,
  cateringPath,
  fairgroundPath,
  golfBrauPath,
  golfHotelPath,
  leQGPath,
  tiniriCampPath,
  treesomePath,
} from '../../assets/paths';

class AboutGas extends Component {
  render() {
    return (
        <section className={this.props.background} id="about">
          <div className="container">
            <div className="pt-5 pb-2">
              <div className="col-12 mb-5 txt-bold-40px txt-purple txt-uppercase">Golf advanced services</div>
              <div style={{ position: 'relative' }}>
                <p className="txt-thin">
                  GAS est une société située au cœur de la ville de Sousse possédant une chaîne de restaurants, bars, hôtels,
                  cafés, boîtes de nuit et plusieurs autres centres d’animation et de loisirs.
                </p>
                <hr className="rule-white" />
                <p className="txt-thin mt-3 mb-5">
                  Notre savoir-faire: c’est la création, la promotion, l’organisation, la gestion d’événements à caractère
                  touristique, festif, culturel… autour d’un thème toujours particulier et des services personnalisés pour tout
                  événement privé; soirées privées, séminaires, congrès, dîners d’affaires, Team-building, outside catering et
                  autres. Pour tous vos événements au sein de nos établissements, nous vous proposons: - Une variété d’artistes et
                  de spectacles assurés par des artistes nationaux et internationaux. - Transports en bus, minibus et voitures
                  individuelles. - Logement à l’hôtel Golf Résidence El Kantaoui, à l’hôtel Sindbad Sousse ou aux Apparts-Hôtel du
                  QG à des tarifs promotionnels.
                </p>
              </div>
              <div id="groups" className="col-12 m-0 mb-5 row justify-content-center text-white">
                <Rubric image={GolfHotelLogo} text="Visitez" linkTo={golfHotelPath} disabled />
              </div>
              <div id="groups" className="col-12 m-0 mb-5 row justify-content-center text-white">
                <Rubric image={GolfLogo} text="Visitez" linkTo={golfBrauPath} />
                <Rubric image={LeQGLogo} text="Visitez" linkTo={leQGPath} />
                <Rubric image={TreesomeLogo} text="Visitez" linkTo={treesomePath} />
                <Rubric image={ArtistoLogo} text="Visitez" linkTo={artistoPath} />
                <Rubric image={CateringLogo} text="Visitez" linkTo={cateringPath} />
              </div>
              <div id="groups" className="col-12 m-0 mb-5 row justify-content-center text-white">
                <Rubric image={TiniriCampLogo} text="Visitez" linkTo={tiniriCampPath} disabled />
                <Rubric image={FairgroundLogo} text="Visitez" linkTo={fairgroundPath} />
              </div>
            </div>
          </div>
        </section>
    );
  }
}

const Rubric = ({ image, text, linkTo: linkTo, disabled }) => disabled ?
    <a href="#" className="col justify-content-center align-items-center">
      <img className="m-2" src={image} style={{ maxWidth: 100, height: 80 }}  alt="logo"/>
      <br />
      <button
          disabled={disabled}
          className="btn-custom btn-silver mb-4"
          style={{ opacity: disabled ? 0.5 : undefined, cursor: disabled ? 'not-allowed' : undefined }}
      >
        {text}
      </button>
    </a>
    : <Link to={linkTo} className="col justify-content-center align-items-center">
      <img className="m-2" src={image} style={{ maxWidth: 100, height: 80 }}  alt="logo"/>
      <br />
      <button
          disabled={disabled}
          className="btn-custom btn-silver mb-4"
          style={{ opacity: disabled ? 0.5 : undefined, cursor: disabled ? 'not-allowed' : undefined }}
      >
        {text}
      </button>
    </Link>;

export default AboutGas;



// WEBPACK FOOTER //
// ./src/components/gas/AboutGas.jsx